import React from 'react'
import { useCleanPostData } from '@features/post/contexts/CleanPostDataContext'
import { getCoverImage } from '../libs/postTools'
import { imageUrl, shaperUrl } from '@libs/appUrl'
import { useTranslation } from '@i18n'

function useOpenGraphTags() {
  const { t } = useTranslation('common')
  const {
    post,
    url: postUrl,
    ogTitle: postTitle = '',
    ogDescription = '',
    ogImagePath: postOgImagePath,
    editorType,
  } = useCleanPostData()

  const suffix = `${t('PopDaily')} ${t('波波黛莉')}`
  const ogTitle = `${postTitle} | ${suffix}`
  const coverImage = getCoverImage(post)
  let ogImageUrl = ''
  let ogImageWidth = 1200
  let ogImageHeight = 630
  if (editorType === 'creator-v2') {
    ogImageUrl = postOgImagePath
      ? imageUrl(postOgImagePath)
      : shaperUrl(coverImage.path)({ 'resize-w': 1200, 'resize-h': 630 })
  } else {
    ogImageUrl = coverImage.url
    ogImageWidth = coverImage.width
    ogImageHeight = coverImage.height
  }

  return (
    <>
      <meta key="og:type" property="og:type" content="article" />
      <meta key="og:url" property="og:url" content={postUrl} />
      <meta key="og:title" property="og:title" content={ogTitle} />
      <meta key="og:description" property="og:description" content={ogDescription} />
      <meta key="og:image" property="og:image" content={ogImageUrl} />
      <meta key="og:image:width" property="og:image:width" content={ogImageWidth.toString()} />
      <meta key="og:image:height" property="og:image:height" content={ogImageHeight.toString()} />
      {ogImageUrl.startsWith('https') && (
        <meta key="og:image:secure_url" property="og:image:secure_url" content={ogImageUrl} />
      )}
      <meta key="twitter:title" property="twitter:title" content={ogTitle} />
      <meta key="twitter:description" property="twitter:description" content={ogDescription} />
      <meta key="twitter:image" property="twitter:image" content={ogImageUrl} />
    </>
  )
}

export default useOpenGraphTags
